import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function PaymentResultPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { status, subscriptionID } = location.state || {};

  const handleBack = () => {
    try {
      navigate('/register'); // or '/login'
    } catch (error) {
      console.error('Navigation error:', error);
      // Optionally show an error message to the user
      // e.g., Swal.fire('Error', 'Failed to navigate.', 'error');
    }
  };
  
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      {status === 'success' ? (
        <>
          <h2 style={{ color: 'green' }}>🎉 Subscription Successful!</h2>
          <p>Subscription ID: <strong>{subscriptionID}</strong></p>
        </>
      ) : status === 'fail' ? (
        <h2 style={{ color: 'red' }}>❌ Payment Failed. Please try again.</h2>
      ) : (
        <h2 style={{ color: 'orange' }}>⚠️ Payment Cancelled.</h2>
      )}
      <button onClick={handleBack} style={{ marginTop: '20px' }}>Go to Dashboard</button>
    </div>
  );
}

export default PaymentResultPage;
